module.exports = __webpack_public_path__ + "img/statistikk_compressed.5f2beaab.jpg";